import { getHrefUrl } from './../url/get-href-url.js';

import type { LinkOldOrNew } from './types.js';

export const getLinkHrefUrl = (link: LinkOldOrNew, baseUrl?: string): string | undefined =>
  typeof link.url === 'string' && link.url
    ? getHrefUrl(link.url, baseUrl)
    : typeof link.anchor === 'string'
      ? `#viewer-${link.anchor}`
      : undefined;
